import React, { useState } from "react"
import GenericModal from "../generic-modal/generic-modal"
import "./change-address.scss"
import Button from "../../atoms/button/button"

const ChangeAddress = props => {
  const {
    setModalChangeAdress,
    addressValue,
    setaddressValue,
    addressDetailValue,
    setaddressDetailValue,
  } = props
  const [adress, setAdress] = useState({
    search: addressValue,
    value: addressValue,
  })

  const handleInputAddressChange = e => {
    let __address = { search: e.target.value, value: e.target.value }
    setaddressValue(__address.value)
    setAdress(() => __address)
  }

  const handleChangeAdressDetail = e => {
    setaddressDetailValue(e.target.value)
  }

  const houseCopie =
    process.env.LOCALE === "es-PE"
      ? "Urbanización / N° Departamento / Referencia"
      : process.env.LOCALE === "es-DO"
      ? "Sector / edificio / apartamento"
      : "Barrio / edificio / apartamento"

  const copieExample =
    process.env.LOCALE === "es-PE"
      ? "Ejemplo: Urbanización El Portal, Apto 1005, unidad portal Del Valle"
      : process.env.LOCALE === "es-DO"
      ? "Ejemplo: Sector El Portal, unidad portal Del Valle, Apto 1005"
      : "Ejemplo: Barrio El Portal, unidad portal Del Valle, Apto 1005"

  return (
    <div className="f-change-address">
      <GenericModal>
        <span
          className="icon2-close f-close-icon"
          onClick={() => setModalChangeAdress(null)}
        />
        <div className="f-change-address-item">
          <h2 className="f-change-address-item-title">
            Actualiza tu dirección
          </h2>
        </div>
        <div className="f-change-address-item">
          <div>
            <label>TU DIRECCIÓN{props.adult && <span> (Opcional)</span>}</label>
            <input
              type="text"
              value={adress.value}
              placeholder="Dirección"
              onChange={event => {
                if (!(/^[ a-zA-Z0-9#°áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ,.;:()¿?¡!_-]+$/).test(event.target.value)) {
                    return false;
                }else{
                   handleInputAddressChange(event)
                }
            }}
              className="f-change-address-input-address-additional"
            />
          </div>
        </div>
        <div className="f-change-address-item">
          <div>
            <label>
              DATOS ADICIONALES DE TU UBICACIÓN
              {props.adult && <span> (Opcional)</span>}
            </label>
            <input
              placeholder={houseCopie}
              type="text"
              name="addressAdditional"
              className="f-change-address-input-address-additional"
              maxLength="60"
              autoComplete="off"
              id={"outlined-address-additional"}
              defaultValue={addressDetailValue}
              onChange={event => {
                if (!(/^[ a-zA-Z0-9#°áéíóúÁÉÍÓÚäëïöüÄËÏÖÜñÑ,.;:()¿?¡!_-]+$/).test(event.target.value)) {
                    return false;
                }else{
                   handleChangeAdressDetail(event)
                }
            } }
            />
            <p className="f-change-address-copy">{copieExample}</p>
          </div>
        </div>
        <div onClick={() => setModalChangeAdress(null)}>
          <Button className="primary-pink short" title="Aceptar" />
        </div>
        <br />
        <br />
        <br />
      </GenericModal>
    </div>
  )
}

export default ChangeAddress
